export default {
  home: '/',
  terms: '/terms',
  activate: '/activate',
  activateInstationApp: '/activate-instation-app',
  acceptTerms: '/acceptTerms',
  permissions: '/permissions',
  install: '/install',
  alreadyExists: '/already-exists',
};
